export const environment = {
  production: false,
  apiUrl: 'https://api.cysm-dev.fspectrum.tech/api/V1/',
  wsUrl: 'wss://api.cysm-dev.fspectrum.tech/api/V1/ws',
  // apiUrl: 'http://localhost:8080/api/V1/',
  // wsUrl: 'ws://localhost:8080/api/V1/ws',
};
